import React from "react";
import { Box, Typography } from "@mui/material";

export default function PrivacyPage() {
  return (
    <Box sx={{ maxWidth: 760, mx: "auto", px: 2, py: 5 }}>
      <Typography variant="h4" fontWeight={600} sx={{ mb: 1 }}>
        TrustBud Privacy Policy
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Last updated: Jan 6, 2026
      </Typography>

      <Typography variant="h6" fontWeight={600} sx={{ mt: 3, mb: 1 }}>
        Introduction
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
        TrustBud is a habit and accountability app. This policy explains what we
        collect, how we use it, and the choices you have.
      </Typography>

      <Typography variant="h6" fontWeight={600} sx={{ mt: 3, mb: 1 }}>
        Information We Collect
      </Typography>
      <Box component="ul" sx={{ pl: 3, color: "text.secondary", m: 0 }}>
        <li>Account information such as email and username.</li>
        <li>User-generated content like goals, habits, check-ins, and messages.</li>
        <li>Profile photos if you choose to upload one.</li>
        <li>Basic usage data needed to run the app and keep it reliable.</li>
      </Box>

      <Typography variant="h6" fontWeight={600} sx={{ mt: 3, mb: 1 }}>
        How We Use Information
      </Typography>
      <Box component="ul" sx={{ pl: 3, color: "text.secondary", m: 0 }}>
        <li>To operate the app and keep your account working.</li>
        <li>To provide accountability features you choose to use.</li>
        <li>To send notifications you request or enable.</li>
      </Box>

      <Typography variant="h6" fontWeight={600} sx={{ mt: 3, mb: 1 }}>
        Data Sharing
      </Typography>
      <Box component="ul" sx={{ pl: 3, color: "text.secondary", m: 0 }}>
        <li>We do not sell your data.</li>
        <li>We do not share your data with advertisers.</li>
        <li>
          Your data is shared only with your TrustBud when you explicitly connect
          with someone.
        </li>
      </Box>

      <Typography variant="h6" fontWeight={600} sx={{ mt: 3, mb: 1 }}>
        Data Retention
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
        We keep your data while your account is active. When you delete your
        account, we delete your data.
      </Typography>

      <Typography variant="h6" fontWeight={600} sx={{ mt: 3, mb: 1 }}>
        User Rights
      </Typography>
      <Box component="ul" sx={{ pl: 3, color: "text.secondary", m: 0 }}>
        <li>Access your data.</li>
        <li>Correct your data.</li>
        <li>Delete your account and data from within the app.</li>
      </Box>

      <Typography variant="h6" fontWeight={600} sx={{ mt: 3, mb: 1 }}>
        Security
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
        We store data securely and work to protect it from unauthorized access.
      </Typography>

      <Typography variant="h6" fontWeight={600} sx={{ mt: 3, mb: 1 }}>
        Contact Information
      </Typography>
      <Typography variant="body1" color="text.secondary">
        If you have questions, contact{" "}
        <a href="mailto:support@trustbud.app">support@trustbud.app</a>.
      </Typography>
    </Box>
  );
}
